/**
 * Product form: variant selection, Add to Cart price update, Subscribe & Save toggle.
 */
(function () {
  function init() {
    document.querySelectorAll('.zpro-form').forEach(function (formBlock) {
      var form = formBlock.querySelector('.bg-product-form');
      if (!form) return;

      var variantInput = form.querySelector('.bg-variant-id-input');
      var variantCards = formBlock.querySelectorAll('.bg-variant');
      var frequencyWrap = formBlock.querySelector('.bg-subscription__frequency-wrap');
      var frequencyDivs = frequencyWrap ? frequencyWrap.querySelectorAll('.bg-subscription__frequency') : [];
      var addToCartBtn = form.querySelector('.bg-add-to-cart');
      var priceEl = addToCartBtn && addToCartBtn.querySelector('.bg-add-to-cart__price');
      var compareEl = addToCartBtn && addToCartBtn.querySelector('.bg-add-to-cart__compare');
      var quantityInput = form.querySelector('.bg-quantity-input');
      var selectedPackInput = form.querySelector('.bg-selected-pack-input');

      function getCurrencyCode() {
        var afterpayWrap = formBlock.querySelector('.pdp-afterpay-wrapper');
        var code = (afterpayWrap && afterpayWrap.getAttribute('data-currency')) || 'USD';
        return String(code).toUpperCase();
      }

      function formatMoneyAmountDigits(amount) {
        try {
          return new Intl.NumberFormat(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(amount);
        } catch (e) {
          return amount.toFixed(2);
        }
      }

      function formatMoney(cents) {
        var amount = (parseInt(cents, 10) || 0) / 100;
        var code = getCurrencyCode();
        /* AUD (and similar) via Intl often renders as "A$" — use plain "$" + localized digits. */
        if (code === 'AUD') {
          return '$' + formatMoneyAmountDigits(amount);
        }
        try {
          return new Intl.NumberFormat(undefined, {
            style: 'currency',
            currency: code,
            currencyDisplay: 'narrowSymbol',
          }).format(amount);
        } catch (e) {
          return '$' + formatMoneyAmountDigits(amount);
        }
      }

      function getCardId(card) {
        return card ? (card.getAttribute('data-card-id') || card.getAttribute('data-variant-id')) : null;
      }

      function getCardById(cardId) {
        if (!cardId) return null;
        var byCardId = formBlock.querySelector('.bg-variant[data-card-id="' + cardId + '"]');
        if (byCardId) return byCardId;
        return formBlock.querySelector('.bg-variant[data-variant-id="' + cardId + '"]');
      }

      function decodeEntities(input) {
        if (!input) return '';
        var el = document.createElement('textarea');
        el.innerHTML = input;
        return el.value;
      }

      function getVisibleSelect() {
        if (!frequencyWrap) return null;
        for (var i = 0; i < frequencyDivs.length; i++) {
          if (window.getComputedStyle(frequencyDivs[i]).display !== 'none') {
            var sel = frequencyDivs[i].querySelector('.bg-subscription__select');
            if (sel) return sel;
          }
        }
        return null;
      }

      function getSelectForCard(card) {
        if (!frequencyWrap) return null;
        var cardId = getCardId(card);
        if (cardId) {
          var byCardId = frequencyWrap.querySelector('.bg-subscription__frequency[data-card-id="' + cardId + '"]');
          if (byCardId) return byCardId.querySelector('.bg-subscription__select');
        }
        var variantId = card && card.getAttribute('data-variant-id');
        if (variantId) {
          var byVariant = frequencyWrap.querySelector('.bg-subscription__frequency[data-variant-id="' + variantId + '"]');
          if (byVariant) return byVariant.querySelector('.bg-subscription__select');
        }
        return getVisibleSelect();
      }

      /** Plan % off variant price + block “extra subscription” % (additive, for badges / /discount/). */
      function getAdditiveSubscriptionSavePercent(card) {
        if (!card) return null;
        var unitPriceCents = parseInt(card.getAttribute('data-unit-price-cents'), 10) || 0;
        var extraSub = parseInt(card.getAttribute('data-subscription-discount-percent'), 10) || 0;
        var sel = getSelectForCard(card);
        var planUnitPriceCents = NaN;
        if (sel && sel.options.length > 0) {
          var opt = sel.options[sel.selectedIndex] || sel.options[0];
          planUnitPriceCents = opt ? parseInt(opt.getAttribute('data-plan-price-cents'), 10) : NaN;
        }
        var planOffPct = 0;
        if (!isNaN(planUnitPriceCents) && unitPriceCents > 0) {
          planOffPct = Math.round((unitPriceCents - planUnitPriceCents) / unitPriceCents * 100);
          if (planOffPct < 0) planOffPct = 0;
        }
        var sum = planOffPct + extraSub;
        if (sum <= 0) return null;
        return sum > 100 ? 100 : sum;
      }

      function computeCardPrices(card, subscribed) {
        var unitPriceCents = parseInt(card.getAttribute('data-unit-price-cents'), 10) || 0;
        var compareUnitCents = parseInt(card.getAttribute('data-unit-compare-cents'), 10);
        if (isNaN(compareUnitCents) || compareUnitCents <= 0) compareUnitCents = unitPriceCents;
        var quantity = parseInt(card.getAttribute('data-quantity'), 10) || 1;
        var discountPercent = parseInt(card.getAttribute('data-discount-percent'), 10) || 0;
        var subscriptionDiscountPercent = parseInt(card.getAttribute('data-subscription-discount-percent'), 10) || 0;

        // One-time: base unit × (1 − one-time discount). Subscription: plan unit × (1 − extra sub discount), not chained from one-time.
        var oneTimeUnitCents = Math.round(unitPriceCents * (100 - discountPercent) / 100);
        var subscribedUnitCents = oneTimeUnitCents;
        if (subscribed) {
          var sel = getSelectForCard(card);
          if (sel && sel.options.length > 0) {
            var opt = sel.options[sel.selectedIndex] || sel.options[0];
            var planUnitPriceCents = opt ? parseInt(opt.getAttribute('data-plan-price-cents'), 10) : NaN;
            if (!isNaN(planUnitPriceCents) && planUnitPriceCents >= 0) {
              // Ceil to whole cents after extra sub % (e.g. 42.712 → 42.72) so qty×unit matches spreadsheet-style totals.
              var subNumerator = planUnitPriceCents * (100 - subscriptionDiscountPercent);
              subscribedUnitCents = Math.floor((subNumerator + 99) / 100);
            }
          }
        }
        // Step 3: multiply by qty.
        var activeUnitCents = subscribed ? subscribedUnitCents : oneTimeUnitCents;

        return {
          quantity: quantity,
          oneTimeUnitCents: oneTimeUnitCents,
          subscribedUnitCents: subscribedUnitCents,
          totalCents: activeUnitCents * quantity,
          oneTimeTotalCents: oneTimeUnitCents * quantity,
          compareTotalCents: compareUnitCents * quantity
        };
      }

      function updatePriceForCard(cardId, updateAddToCart) {
        var card = getCardById(cardId);
        if (!card) return;

        var baseCompare = card.getAttribute('data-compare-price') || '';

        var toggle = formBlock.querySelector('.bg-subscription__toggle-input');
        var subscribed = toggle && toggle.checked;
        var totals = computeCardPrices(card, subscribed);
        var finalPrice = formatMoney(totals.totalCents);
        var baselineCents = totals.compareTotalCents > 0 ? totals.compareTotalCents : totals.oneTimeTotalCents;
        var finalCompare = baseCompare || formatMoney(totals.compareTotalCents);
        var isActive = card.classList.contains('bg-variant--active');
        if (updateAddToCart !== false && isActive && priceEl) priceEl.textContent = finalPrice;
        if (isActive) {
          var afterpayWrap = formBlock.querySelector('.pdp-afterpay-wrapper');
          var afterpayEl = afterpayWrap && afterpayWrap.querySelector('.sb-afpay');
          if (afterpayEl) {
            var afterpayCents = Math.round(totals.totalCents / 4);
            var apAmount = afterpayCents / 100;
            var apCode = getCurrencyCode();
            if (apCode === 'AUD') {
              afterpayEl.textContent = '$' + formatMoneyAmountDigits(apAmount);
            } else {
              try {
                afterpayEl.textContent = new Intl.NumberFormat(undefined, {
                  style: 'currency',
                  currency: apCode,
                  currencyDisplay: 'narrowSymbol',
                }).format(apAmount);
              } catch (e) {
                afterpayEl.textContent = '$' + formatMoneyAmountDigits(apAmount);
              }
            }
          }
        }
        if (updateAddToCart !== false && isActive && compareEl) {
          if (finalCompare && finalCompare !== finalPrice) {
            compareEl.innerHTML = '<s>' + finalCompare + '</s>';
            compareEl.style.display = '';
          } else {
            compareEl.innerHTML = '';
            compareEl.style.display = 'none';
          }
        }

        var cardAmount = card.querySelector('[data-display-price]');
        var cardCompare = card.querySelector('[data-display-compare]');
        var cardSave = card.querySelector('.bg-variant-save');
        if (cardAmount) cardAmount.textContent = finalPrice;
        if (cardCompare) {
          if (finalCompare && totals.compareTotalCents > totals.totalCents) {
            cardCompare.innerHTML = '<s>' + finalCompare + '</s>';
            cardCompare.style.display = '';
          } else {
            cardCompare.innerHTML = '';
            cardCompare.style.display = 'none';
          }
        }
        if (cardSave) {
          if (subscribed) {
            var addSubPct = getAdditiveSubscriptionSavePercent(card);
            if (addSubPct != null) {
              var displaySubPct = addSubPct > 20 ? 20 : addSubPct;
              cardSave.textContent = 'Save ' + displaySubPct + '%';
              cardSave.style.display = '';
            } else {
              cardSave.style.display = 'none';
            }
          } else if (baselineCents > 0 && totals.totalCents < baselineCents) {
            var savePctOt = Math.round((baselineCents - totals.totalCents) / baselineCents * 100);
            var displayOtPct = savePctOt > 20 ? 20 : savePctOt;
            cardSave.textContent = 'Save ' + displayOtPct + '%';
            cardSave.style.display = '';
          } else {
            cardSave.style.display = 'none';
          }
        }

        var perdayEl = card.querySelector('.bg-variant-perday');
        if (perdayEl) {
          var sizeperpack = parseInt(card.getAttribute('data-sizeperpack'), 10) || 1;
          var perdayOnetime = card.getAttribute('data-perday-onetime');
          if (subscribed && sizeperpack > 0 && totals.totalCents > 0) {
            var perDayCents = Math.round(totals.totalCents / sizeperpack);
            perdayEl.textContent = 'Only $' + (perDayCents / 100).toFixed(2) + ' p/day';
          } else if (perdayOnetime) {
            perdayEl.textContent = perdayOnetime;
          }
        }
      }

      function updateAllVariantCards() {
        variantCards.forEach(function (card) {
          var id = getCardId(card);
          if (id) updatePriceForCard(id);
        });
      }

      function getSubscriptionDiscountForCard(cardId) {
        var toggle = formBlock.querySelector('.bg-subscription__toggle-input');
        if (!toggle || !toggle.checked) return null;
        var card = getCardById(cardId);
        return getAdditiveSubscriptionSavePercent(card);
      }

      function updateCsubdiscount() {
        var activeCard = formBlock.querySelector('.bg-variant.bg-variant--active') || formBlock.querySelector('.bg-variant');
        var currentId = getCardId(activeCard);
        if (!currentId) return;
        var pct = getSubscriptionDiscountForCard(currentId);
        var displayPct = pct != null ? (pct > 20 ? 20 : pct) : null;
        var text = displayPct != null ? displayPct + '%' : '';
        formBlock.querySelectorAll('.csubdiscount').forEach(function (el) {
          el.textContent = text;
        });
      }

      function renderBenefitsHtml(rawBenefits) {
        if (!rawBenefits) return '';
        var parts = String(rawBenefits).split('/discount/');
        if (parts.length <= 1) return rawBenefits;
        return parts.join('<span class="csubdiscount"></span>');
      }

      function updateSubscriptionBenefits(cardId) {
        var card = getCardById(cardId);
        var benefitsWrap = formBlock.querySelector('.bg-subscription__benefits');
        if (!card || !benefitsWrap) return;
        var rawBenefits = decodeEntities(card.getAttribute('data-subscription-benefits') || '');
        var html = renderBenefitsHtml(rawBenefits);
        if (html) {
          benefitsWrap.innerHTML = '<div class="bg-subscription__benefit rte">' + html + '</div>';
        } else {
          benefitsWrap.innerHTML = '';
        }
        updateCsubdiscount();
      }

      function updateSubscriptionImages(cardId) {
        var card = getCardById(cardId);
        var body = formBlock.querySelector('.bg-subscription__body');
        var toggle = formBlock.querySelector('.bg-subscription__toggle-input');
        var subscribed = !!(toggle && toggle.checked);
        if (!card || !body) return;
        var rawHtml = decodeEntities(card.getAttribute('data-subscription-gifts-html') || '');
        var giftsWrap = body.querySelector('.bg-subscription__gifts');
        if (rawHtml) {
          if (!giftsWrap) {
            giftsWrap = document.createElement('div');
            giftsWrap.className = 'bg-subscription__gifts';
            body.appendChild(giftsWrap);
          }
          giftsWrap.innerHTML = rawHtml;
          giftsWrap.style.display = subscribed ? '' : 'none';
        } else if (giftsWrap) {
          giftsWrap.remove();
        }
      }

      function setVariant(cardId) {
        var activeCard = getCardById(cardId);
        if (!activeCard) return;
        var realVariantId = activeCard.getAttribute('data-variant-id');
        var qty = parseInt(activeCard.getAttribute('data-quantity'), 10) || 1;
        if (variantInput && realVariantId) variantInput.value = realVariantId;
        if (quantityInput) quantityInput.value = String(qty);
        if (selectedPackInput) selectedPackInput.value = String(cardId);
        variantCards.forEach(function (card) {
          if (String(getCardId(card)) === String(cardId)) {
            card.classList.add('bg-variant--active');
          } else {
            card.classList.remove('bg-variant--active');
          }
        });
        frequencyDivs.forEach(function (div) {
          var divCardId = div.getAttribute('data-card-id');
          if (divCardId) {
            div.style.display = String(divCardId) === String(cardId) ? '' : 'none';
          } else {
            var divVariantId = div.getAttribute('data-variant-id');
            if (divVariantId && realVariantId) {
              div.style.display = String(divVariantId) === String(realVariantId) ? '' : 'none';
            } else {
              div.style.display = '';
            }
          }
        });
        updatePriceForCard(cardId);
        updateSubscriptionBenefits(cardId);
        updateSubscriptionImages(cardId);
        updateCsubdiscount();
      }

      variantCards.forEach(function (card) {
        card.addEventListener('click', function () {
          var id = getCardId(card);
          if (id) setVariant(id);
        });
      });

      var firstCard = formBlock.querySelector('.bg-variant');
      var initialCard = formBlock.querySelector('.bg-variant.bg-variant--active') || firstCard;
      var initialCardId = getCardId(initialCard);
      if (initialCardId) {
        setVariant(initialCardId);
      }

      var subscribeDefault = formBlock.getAttribute('data-subscribe-default') === 'true';
      var toggle = formBlock.querySelector('.bg-subscription__toggle-input');
      if (toggle && frequencyWrap) {
        var selects = frequencyWrap.querySelectorAll('.bg-subscription__select');

        function selectFirstPlan() {
          selects.forEach(function (sel) {
            if (sel && sel.options.length > 0) {
              sel.value = sel.options[0].value;
              sel.disabled = false;
            }
          });
        }

        function setSubscribeState(checked) {
          formBlock.setAttribute('data-subscribed', checked ? 'true' : 'false');
          var activeCard = formBlock.querySelector('.bg-variant.bg-variant--active') || formBlock.querySelector('.bg-variant');
          var activeCardId = getCardId(activeCard);
          if (checked) {
            frequencyWrap.style.display = '';
            selects.forEach(function (s) { s.disabled = false; });
            selectFirstPlan();
            updateAllVariantCards();
          } else {
            frequencyWrap.style.display = 'none';
            selects.forEach(function (s) { s.disabled = true; });
            updateAllVariantCards();
          }
          if (activeCardId) updateSubscriptionImages(activeCardId);
          updateCsubdiscount();
        }

        toggle.addEventListener('change', function () {
          setSubscribeState(toggle.checked);
        });

        selects.forEach(function (s) {
          s.addEventListener('change', function () {
            var freqDiv = s.closest('.bg-subscription__frequency');
            var cardId = freqDiv ? (freqDiv.getAttribute('data-card-id') || freqDiv.getAttribute('data-variant-id')) : null;
            if (cardId) updatePriceForCard(cardId);
            updateAllVariantCards();
            updateCsubdiscount();
          });
        });

        toggle.checked = subscribeDefault;
        setSubscribeState(subscribeDefault);
      } else {
        formBlock.setAttribute('data-subscribed', 'false');
        updateAllVariantCards();
        updateCsubdiscount();
      }

      if (initialCardId) {
        updatePriceForCard(initialCardId);
        updateCsubdiscount();
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
